import { render, staticRenderFns } from "./Boolean.vue?vue&type=template&id=5fa19f83&scoped=true"
import script from "./Boolean.vue?vue&type=script&lang=js"
export * from "./Boolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa19f83",
  null
  
)

export default component.exports